import PropTypes from 'prop-types';
import OptionPropType from './option';

const PeriodPropType = PropTypes.shape({
  startAt: PropTypes.string,
  endAt: PropTypes.string,
});

const VisitActualPatientPropType = PropTypes.shape({
  NhsNumber: PropTypes.string,
  Forename: PropTypes.string,
  Surname: PropTypes.string,
});

const VisitActualActivityPropType = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  minutesSpent: PropTypes.number,
  isAdditional: PropTypes.bool,
  isCompleted: PropTypes.bool,
  reason: PropTypes.string, // info: for incompletion
});

const VisitActualPropType = PropTypes.shape({
  clinicians: PropTypes.arrayOf(OptionPropType),
  planned: PeriodPropType,
  actual: PeriodPropType,
  minutes: PropTypes.number,
  activities: PropTypes.arrayOf(VisitActualActivityPropType),
});

export { VisitActualActivityPropType, VisitActualPatientPropType, VisitActualPropType };
